"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const getNormalStyle = ({ theme }) => ({
    icon: {
        display: "block",
        height: "136px",
        marginBottom: theme.spacing(2),
        marginLeft: "auto",
        marginRight: "auto",
        width: "136px",
    },
    subtitle: {
        marginBottom: theme.spacing(1),
    },
    wrapper: {
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        minWidth: "408px",
    },
});
const getSmallStyle = ({ theme }) => ({
    icon: {
        display: "inline-flex;",
        height: "24px",
        marginLeft: "auto",
        marginRight: theme.spacing(2),
        verticalAlign: "middle",
        width: "24px",
    },
    subtitle: {},
    wrapper: {
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        minWidth: "200px",
    },
});
/**
 *
 * @category component
 */
const CardTitleError = ({ children, Icon, colorText = "textPrimary", colorIcon = "disabled", subtitle, small = false, }) => {
    const theme = (0, material_1.useTheme)();
    const styles = small ? getSmallStyle({ theme }) : getNormalStyle({ theme });
    return (react_1.default.createElement(Box_1.default, { sx: styles.wrapper }, children ? (children) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Typography_1.default, { variant: "subtitle1", align: small ? "left" : "center", color: colorText, sx: styles.subtitle },
            Icon && react_1.default.createElement(Icon, { color: colorIcon, sx: styles.icon }),
            subtitle ? subtitle : "Something went wrong")))));
};
exports.default = CardTitleError;
